export default __webpack_public_path__ + "static/media/lucky-spin-banner-cn.4c2c38e6.webp";